import Vue from 'vue'

// eslint-disable-next-line import/extensions
import EJ2_LOCALE from '@syncfusion/ej2-locale/src/pt-BR.json'
import { registerLicense, L10n, setCulture } from '@syncfusion/ej2-base/src'
import { KanbanPlugin } from '@syncfusion/ej2-vue-kanban'

// eslint-disable-next-line max-len
registerLicense('ORg4AjUWIQA/Gnt2V1hiQlRPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9gSXZRfkVqW39bcXNcT2M=')
L10n.load({ 'pt-BR': EJ2_LOCALE['pt-BR'] })
setCulture('pt-BR')

Vue.use(KanbanPlugin)
